module.exports = __webpack_public_path__ + "static/img/title-ar.af2a4da4.png";